import { Switch } from 'react-router-dom';
import { useModuleFeatureFlag } from '@/providers/FeatureFlag.provider';
import ProtectedRoute from '../../utils/ProtectedRoute';
import { useLockedFeatures } from '../../providers/LockedFeatures.provider';
import AccountingSystemContainer from './AccountingSystem/AccountingSystemContainer';
import CreateInvoicePage from './CreateInvoice/CreateInvoicePage';
import CreateBillPage from './CreateBill/CreateBillPage';
import AccountingEmbedPage from './AccountingEmbed/AccountingEmbedPage';

// Two accounting flows coexist while the new Accounting Software API is
// validated (ID-13335). The current Railz-backed pages keep their routes and
// menu entries; the new VoPay 360 embed is reachable only by URL under
// /accounting/* — nothing links to it.
export default function Routes() {
  const lockedFeatures = useLockedFeatures();
  const featureFlags = useModuleFeatureFlag('software');
  const isAllowed = !!lockedFeatures.AccountingSoftwareIntegrationEnabled && featureFlags.isEnabled;

  return (
    <Switch>
      {/* Current flow */}
      <ProtectedRoute isAllowed={isAllowed} showPermission exact path="/receivables">
        <AccountingSystemContainer Type="Receivable" />
      </ProtectedRoute>

      <ProtectedRoute isAllowed={isAllowed} showPermission exact path="/payables">
        <AccountingSystemContainer Type="Payable" />
      </ProtectedRoute>

      <ProtectedRoute isAllowed={isAllowed} showPermission exact path="/receivables/create-invoice">
        <CreateInvoicePage />
      </ProtectedRoute>

      <ProtectedRoute isAllowed={isAllowed} showPermission exact path="/payables/create-bill">
        <CreateBillPage />
      </ProtectedRoute>

      {/* New flow — orphan pages */}
      <ProtectedRoute isAllowed={isAllowed} showPermission exact path="/accounting/receivables">
        <AccountingEmbedPage type="Receivable" />
      </ProtectedRoute>

      <ProtectedRoute isAllowed={isAllowed} showPermission exact path="/accounting/payables">
        <AccountingEmbedPage type="Payable" />
      </ProtectedRoute>

      <ProtectedRoute isAllowed={isAllowed} showPermission exact path="/accounting/receivables/create-invoice">
        <AccountingEmbedPage type="Receivable" page="create-invoice" />
      </ProtectedRoute>

      <ProtectedRoute isAllowed={isAllowed} showPermission exact path="/accounting/payables/create-bill">
        <AccountingEmbedPage type="Payable" page="create-bill" />
      </ProtectedRoute>
    </Switch>
  );
}
